<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader
        v-if="!initiated"
        ref="skeleton"
        type="table"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-data-table
        v-if="initiated"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [-1],
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.type === 'Domain'
            && item.status_name === 'Active'"
            x-small
            color="success"
            @click="viewDomain(item)"
          >
            Manage NS
          </v-btn>&nbsp;&nbsp;
          <v-btn
            v-if="item.type === 'Domain'"
            x-small
            color="success"
            @click="editDns(item)"
          >
            Edit DNS
          </v-btn>&nbsp;&nbsp;
          <v-btn
            x-small
            color="success"
            v-if="(item.type === 'Hosting' || item.type === 'Hosting Addon Domain')
            && item.status_name === 'Active'"
            @click="loginCpanel(item)"
          >
            Login Cpanel
          </v-btn>&nbsp;&nbsp;
          <v-btn
            x-small
            color="success"
            v-if="(item.type === 'Domain')"
            @click="gotoDomainDoctor(item)"
          >
            Doctor Tool
          </v-btn>&nbsp;&nbsp;
          <v-btn
            x-small
            color="success"
            v-if="(item.type === 'Hosting' || item.type === 'Hosting Addon Domain')"
            @click="gotoDoctor(item)"
          >
            Doctor Tool
          </v-btn>&nbsp;&nbsp;
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentTicketServiceList',
  components: {
  },
  data() {
    return {
      ticketId: 0,
      search: '',
      initiated: false,
      productTypeId: null,
      productTypes: [],
      totalItems: 0,
      items: [],
      strange: false,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Type', value: 'type' },
        { text: 'Service', value: 'service_name' },
        { text: 'Domain', value: 'service_identity' },
        { text: 'Status', value: 'status_name' },
        { text: 'Expiry', value: 'expiry_date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.initiated) {
          this.loadTable();
        }
      },
      deep: true,
    },
  },
  created() {
    this.ticketId = this.$route.params.id;
    this.loadTable();
  },
  methods: {
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('agent/ticket-service/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        product_type_id: this.productTypeId,
        order: `${sortBy}:${sortDesc}`,
        ticket: this.ticketId,
      }).then((response) => {
        this.totalItems = response.data.total;
        this.items = response.data.data;
        this.loading = false;
        this.initiated = true;
      });
    },
    viewDomain(item) {
      this.$router.push({ name: 'AgentDomainDetail', params: { id: item.id } });
    },
    editDns(item) {
      this.$router.push({ name: 'AgentDnsEditor', params: { id: item.id } });
    },
    loginCpanel(item) {
      this.$api.post('agent/cpanel/login', {
        id: item.id,
      }).then((response) => {
        window.open(response.data.data.url, '_blank');
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      });
    },
    gotoDoctor(item) {
      this.$router.push({
        name: 'AgentDoctor',
        params: { tid: this.ticketId, domain: item.service_identity },
      });
    },
    gotoDomainDoctor(item) {
      this.$router.push({
        name: 'AgentDomainDoctor',
        params: { tid: this.ticketId, domain: item.service_identity },
      });
    },
  },
};
</script>

<style scoped>
  table td {
    font-size: 0.75rem !important;
  }

  .product-type-tab .v-tab {
    justify-content: flex-start;
  }

  .product-type-tab .v-chip {
    margin-right: 8px;
  }

  .toolbar {
    margin-bottom: 8px;
  }

  .search-input {
    padding: 0 !important;
  }

  .v-btn-search {
    margin-top: 10px;
    margin-right: 4px;
  }

  .v-btn-more {
    margin-top: 10px;
  }
</style>
